import type { ConferencingMeetingPlatform } from "@app/common/types";

import GoogleMeetLogo from "./GoogleMeetLogo@2x.png";
import TeamsLogo from "./TeamsLogoNoBackground.png";
import WebexLogo from "./WebexLogo@2x.png";
import ZoomLogo from "./ZoomLogoRounded@2x.png";

export const LOGO_FOR_PLATFORM: Record<ConferencingMeetingPlatform, string> = {
  zoom: ZoomLogo,
  meet: GoogleMeetLogo,
  webex: WebexLogo,
  teams: TeamsLogo,
};
